import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Svg } from '../common/Svg.js';
import TeacherStatsShareBar from './TeacherStatsShareBar.js';

function TeacherStatsIntro({ isTeacher, teacherName, teacherProfilePhotoURL, lifetimeFullyFundedProjects, schoolCityAndState, schoolName, schoolURL }) {
    const [showPopup, setShowPopup] = useState(true);

    function backToProject() {
        return isTeacher ? <a href="/teacher/teacher.html" className="button-secondary small">Back to your projects</a> : '';
    }
    function teacherImageURL() {
        return <img className='profileImage' src={teacherProfilePhotoURL} alt={teacherName}></img>;
    }
    function teacherRank() {
        if (lifetimeFullyFundedProjects < 3) {
            return <div className="rank">
                <div aria-label='teacher bronze rank' className="rankImage bronze"></div>
                <p className="bronze">Bronze</p>
            </div>;
        } else if (lifetimeFullyFundedProjects < 10) {
            return <div className="rank">
                <div aria-label='teacher silver rank' className="rankImage silver"></div>
                <p className="silver">Silver</p>
            </div>;
        } else {
            return <div className="rank">
                <div aria-label='teacher gold rank' className="rankImage gold"></div>
                <p className="gold">Gold</p>
            </div>;
        }
    }
    function showShare() {
        return <>{isTeacher &&
            <TeacherStatsShareBar
                secureBaseURL={window.secureBaseURL}
                shareURL={window.shareURL} // Defined globally as a pageSpecificJsVariables
                facebookAppId={window.facebookAppId}
                getTafEmail={window.getTafEmail} // defined in general/sharebar.js
                getTafURL={window.getTafURL} // defined in general/sharebar.js

                getTrackingLink={window.getTrackingLink} // defined in queryParams.js
            />}</>;
    }

    useEffect(() => {
        // If user has dismissed the popup before, don't show it
        if (localStorage.getItem('teacherStatsPopupDismissed')) {
            setShowPopup(false);
        }
    }, []);

    function popup() {
        if (!isTeacher || !showPopup) return null;
        return (<section className='popup'>

            <span onClick={closePopup} onKeyDown={closePopup} role="button" tabIndex={0}><Svg icon='delete' /></span>

            <h4>Hi there!</h4>
            <p>Welcome to your stats page. This is where you can view and share your accomplishments. These numbers will update daily.</p>
            <section className='funFact'>
                <img src='../../../images/teacher/stats/illu_teacher.svg' alt="A leason from teacher"/>
                <p><strong>Fun fact:</strong> the leaves will flourish and grow the more projects you get funded!</p>
            </section>
        </section>);
    }
    function closePopup() {
        localStorage.setItem('teacherStatsPopupDismissed', true);
        setShowPopup(false);
    }

    return (
        <section className="teacherIntro">

            {popup()}

            <section className='teacherProfileWrapper'>
                <section className="imageWrapper">
                    {teacherImageURL()}
                    {teacherRank()}
                </section>
                <h2>{teacherName}</h2>
            </section>

            <section className='teacherInfoTools desktop'>
                <section className="fluid-container">

                    <div className="col col4">
                        {backToProject()}
                    </div>

                    <div className="col col4">
                        <section className='schoolDetails'>
                            <h5><a href={baseURL + schoolURL}><span>{schoolName}</span></a></h5>

                            <h5>{schoolCityAndState}</h5>
                        </section>
                    </div>

                    <div className="col col4">
                        {showShare()}
                    </div>

                </section>
            </section>

            <section className='teacherInfoTools mobile'>
                <section className="fluid-container">

                    <div className="col col4">
                        <section className='schoolDetails'>
                            <h5><a href={baseURL + schoolURL}><span>{schoolName}</span></a></h5>
                            <h5>{schoolCityAndState}</h5>
                        </section>
                    </div>

                    <div className="col col4">
                        {showShare()}
                    </div>

                    <div className="col col4">
                        {backToProject()}
                    </div>

                </section>
            </section>
        </section>
    );
}

TeacherStatsIntro.propTypes = {
    isTeacher: PropTypes.bool.isRequired,
    teacherName: PropTypes.string,
    teacherProfilePhotoURL: PropTypes.string,
    teacherPossessiveScreenName: PropTypes.string,
    schoolName: PropTypes.string,
    schoolCityAndState: PropTypes.string,
    schoolURL: PropTypes.string,
    lifetimeFullyFundedProjects: PropTypes.number,
};

export default TeacherStatsIntro;
